import { createApp } from 'vue'
import { createPinia } from 'pinia'
import App from './App.vue'
import router from './router'
import './style.css'

// Initialize Laravel Echo for real-time notifications
import Echo from 'laravel-echo'
import Pusher from 'pusher-js'

// Use existing Echo type from echo.d.ts
declare global {
  interface Window {
    Pusher: typeof Pusher
  }
}

console.log('🚀 StoryFlame v2 initializing...')

// Set up Laravel Echo for real-time WebSocket communication
window.Pusher = Pusher

window.Echo = new Echo({
  broadcaster: 'reverb',
  key: import.meta.env.VITE_REVERB_APP_KEY,
  wsHost: import.meta.env.VITE_REVERB_HOST,
  wsPort: import.meta.env.VITE_REVERB_PORT ? parseInt(import.meta.env.VITE_REVERB_PORT) : 443,
  wssPort: import.meta.env.VITE_REVERB_PORT ? parseInt(import.meta.env.VITE_REVERB_PORT) : 443,
  wsPath: '/',
  forceTLS: (import.meta.env.VITE_REVERB_SCHEME ?? 'https') === 'https',
  enabledTransports: ['ws', 'wss'],

  // Authorization for private channels
  authorizer: (channel: any) => {
    return {
      authorize: (socketId: string, callback: Function) => {
        const token = localStorage.getItem('auth_token')

        fetch('/broadcasting/auth', {
          method: 'POST',
          headers: {
            'Content-Type': 'application/json',
            'Authorization': token ? `Bearer ${token}` : '',
          },
          body: JSON.stringify({
            socket_id: socketId,
            channel_name: channel.name,
          }),
        })
          .then(response => {
            if (!response.ok) {
              throw new Error(`Authorization failed: ${response.status}`)
            }
            return response.json()
          })
          .then(data => callback(null, data))
          .catch(error => {
            console.error('Echo authorization error:', error)
            callback(error)
          })
      }
    }
  }
})

console.log('📡 Laravel Echo initialized for real-time notifications')

const app = createApp(App)
const pinia = createPinia()

console.log('📦 Creating Pinia instance:', !!pinia)

// Enable Vue DevTools in production for development workflow
if (typeof window !== 'undefined') {
  // @ts-ignore
  window.__VUE_DEVTOOLS_GLOBAL_HOOK__ && (window.__VUE_DEVTOOLS_GLOBAL_HOOK__.Vue = app)
  // @ts-ignore
  app.config.devtools = true
  
  // Expose Pinia globally for debugging
  // @ts-ignore
  window.__PINIA__ = pinia
  console.log('🌍 Pinia exposed globally for debugging')
}

app.use(pinia)
app.use(router)

console.log('⚡ Mounting Vue app...')
app.mount('#app')
console.log('✅ Vue app mounted successfully')